























































import assert from 'assert'
import FormContainer from '@/mixins/form-container'
import participanteService from '../services/participante'
import Swal from 'sweetalert2'
import Worker from '@/components/Worker.vue'

export default FormContainer.extend({
  components: {
    Worker,
  },
  data() {
    return {
      password: '',
      confirmPass: '',
      noValido: false,
      valido: false,
      token: (this.$route.query.token as string) || null,
      show: false,
      show2: false,
    }
  },

  methods: {
    submit() {
      return participanteService
        .changePassword(this.token, this.password)
        .then((resp: any) => {
          if (resp.ok) {
            this.msExito()
          } else {
            this.msError()
          }
        })
        .catch(() => {
          this.msError()
        })
    },

    match() {
      return (
        this.confirmPass === this.password || 'Las constraseñas no coinciden'
      )
    },

    async validarToken() {
      try {
        const { token } = this
        assert(token)
        const { valido } = await this.$store.dispatch(
          'session/authenticate',
          token
        )
        assert(valido)
        this.valido = valido
      } catch (err) {
        this.msNoValido()
      }
    },

    async msExito() {
      await Swal.fire(
        'Éxito',
        'Su contraseña se actualizó correctamente',
        'success'
      ).then(() => {
        this.$router.push('/login')
      })
    },

    async msError() {
      await Swal.fire(
        'Error',
        'No fue posible actualizar su contraseña, por favor intente más tarde',
        'error'
      )
    },

    async msNoValido() {
      await Swal.fire('Error', 'Solicitud no autorizada', 'warning').then(
        () => {
          this.$router.push('/home')
        }
      )
    },
  },

  created() {
    this.validarToken()
  },
})
